export const useErrorParams = () => {
  const search = new URLSearchParams(window.location.search);
  if (search.has('error')) {
    const queryString = search.toString();
    window.location.href = `${window.location.origin}/ui/login/error?${queryString}`;
  }
};

export default useErrorParams;
